// extracted by mini-css-extract-plugin
module.exports = {"aiwrapper":"AIWrapper_aiwrapper__3Urul","slider":"AIWrapper_slider__3hQ5R"};